var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF870F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_29563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.167 15.0003C13.167 15.4866 13.3601 15.9529 13.704 16.2967C14.0478 16.6405 14.5141 16.8337 15.0003 16.8337C15.4866 16.8337 15.9529 16.6405 16.2967 16.2967C16.6405 15.9529 16.8337 15.4866 16.8337 15.0003C16.8337 14.5141 16.6405 14.0478 16.2967 13.704C15.9529 13.3601 15.4866 13.167 15.0003 13.167C14.5141 13.167 14.0478 13.3601 13.704 13.704C13.3601 14.0478 13.167 14.5141 13.167 15.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 15C21.05 18.6667 18.3 20.5 15 20.5C11.7 20.5 8.95 18.6667 6.75 15C8.95 11.3333 11.7 9.5 15 9.5C18.3 9.5 21.05 11.3333 23.25 15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_29563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.211b4d309b96b72d92f685596fd806c4.svg";
export { ForwardRef as ReactComponent };